<template>
  <div class="login-page">
    <Snackbar :SnackBarComponent="SnackBarComponent" />
    <div class="login-page__bg" aria-hidden="true"></div>

    <div class="login-page__card-wrap">
      <div class="login-page__card-glow" aria-hidden="true"></div>
      <v-card class="login-page__card" elevation="0">
        <div class="login-page__card-accent" aria-hidden="true"></div>
        <div class="login-page__card-inner">
          <header class="login-page__card-header">
            <v-img
              src="@/assets/vozcarelogo.png"
              class="login-page__brand-logo"
              width="120"
            ></v-img>
            <div class="login-page__card-header-text">
              <p class="login-page__welcome">{{ currentTitle }}</p>
              <p class="login-page__welcome-sub">
                {{
                  step === 1
                    ? "Sign in to continue to your admin workspace"
                    : "We've emailed a 6-digit code to " + OTPLogin.EmailID
                }}
              </p>
            </div>
          </header>

          <v-card-text class="pa-0">
            <v-window v-model="step" class="px-0">
                  <v-window-item :value="1">
                    <v-card-text>
                      <v-form ref="formOTPLoginEmail" lazy-validation class="mt-2">
                        <v-text-field
                          variant="outlined"
                          density="compact"
                          label="Email ID *"
                          prepend-inner-icon="mdi-email-outline"
                          :rules="[(v) => !!v || 'Email ID is required']"
                          v-model="OTPLogin.EmailID"
                          @keyup.enter="SendOTPLoginCode()"
                        ></v-text-field>
                      </v-form>
                    </v-card-text>
                    <v-card-actions class="pt-0 pb-2">
                      <v-btn
                        block
                        :loading="loading"
                        variant="flat"
                        color="primary"
                        @click="SendOTPLoginCode()"
                        >Send Code</v-btn
                      >
                    </v-card-actions>
                  </v-window-item>
                  <v-window-item :value="2">
                    <v-card-text>
                      <v-form ref="formOTPLoginCode" lazy-validation class="mt-2">
                        <v-otp-input
                          v-model="OTPLogin.Code"
                          length="6"
                          type="number"
                          variant="outlined"
                          class="login-page__otp-field"
                          :disabled="loading"
                          @finish="VerifyOTPLoginCode()"
                        ></v-otp-input>
                      </v-form>
                    </v-card-text>
                    <v-card-actions class="pt-0 pb-2">
                      <v-btn
                        block
                        :loading="loading"
                        variant="flat"
                        color="primary"
                        @click="VerifyOTPLoginCode()"
                        >Verify & Sign In</v-btn
                      >
                    </v-card-actions>
                    <v-card-actions class="pt-0 justify-center">
                      <v-btn small text class="FontSize" color="primary fontStyle" @click="step = 1"
                        >Use a different email</v-btn
                      >
                    </v-card-actions>
                  </v-window-item>
                </v-window>
          </v-card-text>
        </div>
      </v-card>
    </div>
  </div>
</template>
<script>
import Snackbar from "@/components/Extras/SnackbarComp.vue";
import {
  signIn,
  resetPassword,
  confirmResetPassword,
  confirmSignIn,
  getCurrentUser,
} from "@aws-amplify/auth";

export default {
  components: {
    Snackbar,
  },
  data: () => ({
    height: 0,
    step: 1,
    Login: {
      EmailID: "",
      Password: "",
    },
    isPwd: false,
    loading: false,
    Password: {
      NewPassword: "",
      ConfirmPassword: "",
    },
    isPwdNew: false,
    isPwdConfirm: false,
    SnackBarComponent: {},
    OTPEmail: "",
    ConfirmOTP: "",
    ConfirmNewPassword: "",
    ReenterNewPassword: "",
    isPwdConfirmCode: false,
    rememberme: false,
    OTPLogin: {
      EmailID: "",
      Code: "",
    },
    otpSignInResult: null,
  }),
  watch: {
    rememberme(val) {
      if (val == true) {
        localStorage.setItem("currentuseremail", JSON.stringify(this.Login));
      } else if (val == false) {
        delete localStorage.currentuseremail;
      }
    },
  },
  computed: {
    currentTitle() {
      switch (this.step) {
        case 1:
        case 2:
          return "BMS - Sign In";
        default:
          return "BMS - Sign In";
      }
    },
  },
  mounted() {
    this.CheckRememberMe();
    this.height = window.innerHeight;
  },
  methods: {
    CheckRememberMe() {
      if (localStorage.getItem("currentuseremail") != null) {
        this.Login = JSON.parse(localStorage.getItem("currentuseremail"));
        this.rememberme = true;
      }
    },
    ConfirmOTPMethod() {
      confirmResetPassword({
        username: this.OTPEmail,
        confirmationCode: this.ConfirmOTP,
        newPassword: this.ConfirmNewPassword,
      })
        .then(() => {
          this.$refs.formConfirmOTP.reset();
          this.SnackBarComponent = {
            SnackbarVmodel: true,
            SnackbarColor: "green",
            Top: true,
            SnackbarText: "Password Successfully Changed ",
          };
          this.step = 1;
        })
        .catch((err) => {
          this.SnackBarComponent = {
            SnackbarVmodel: true,
            SnackbarColor: "red",
            Top: true,
            SnackbarText: err.message,
          };
        });
    },
    async ValidateEnteredOTP() {
      const isValid = await this.$refs.formConfirmOTP.validate();
      if (isValid.valid) {
        if (this.ReenterNewPassword == this.ConfirmNewPassword) {
          this.ConfirmOTPMethod();
        } else {
          this.SnackBarComponent = {
            SnackbarVmodel: true,
            SnackbarColor: "red",
            Top: true,
            SnackbarText: "Password Does not match",
          };
        }
      } else {
        this.SnackBarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "red",
          Top: true,
          SnackbarText: "Please Enter The Code Sent To Registered Email",
        };
      }
    },
    async ValidateOTP() {
      const isValid = await this.$refs.formOTP.validate();
      if (isValid.valid) {
        this.SendOTPEmail();
      } else {
        this.SnackBarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "red",
          Top: true,
          SnackbarText: "Please Enter Registered Email",
        };
      }
    },
    SendOTPEmail() {
      resetPassword(this.OTPEmail)
        .then(() => {
          this.SnackBarComponent = {
            SnackbarVmodel: true,
            SnackbarColor: "green",
            Top: true,
            SnackbarText: "OTP Sent To Registered Email",
          };
          this.step = 4;
        })
        .catch((err) => {
          this.SnackBarComponent = {
            SnackbarVmodel: true,
            SnackbarColor: "red",
            Top: true,
            SnackbarText: err.message,
          };
        });
    },
    async ConfirmPassword() {
      try {
        this.loading = true;
        const result = await confirmSignIn({
          challengeResponse: this.Password.ConfirmPassword,
        })
          .then((user) => {
            return user;
          })
          .catch((e) => {
            this.SnackBarComponent = {
              SnackbarVmodel: true,
              SnackbarColor: "red",
              Top: true,
              SnackbarText: e,
            };
            return e;
          });
        if (result.username) {
          this.loading = false;
          this.SnackBarComponent = {
            SnackbarVmodel: true,
            SnackbarColor: "green",
            Top: true,
            SnackbarText: "Login Successful",
          };
          this.$refs.formCP.reset();
          this.ActivateMethod();
        }
        this.loading = false;
      } catch (error) {
        this.loading = false;
        this.SnackBarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "red",
          Top: true,
          SnackbarText: error.message,
        };
      }
    },
    async SignIn() {
      try {
        this.loading = true;

        // ✅ prevent "already authenticated" error
        try {
          await getCurrentUser();
          this.$router.push("/LandingPage");
          this.loading = false;
          return;
        } catch (e) {
          // not signed in — continue
        }

        const result = await signIn({
          username: this.Login.EmailID,
          password: this.Login.Password,
        });

        this.user = result;

        // ✅ Amplify v6 challenge handling
        if (
          result.nextStep &&
          result.nextStep.signInStep ===
            "CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED"
        ) {
          this.step = 2;
          this.$store.commit("SET_USEREMAIL", this.Login.EmailID);
          this.loading = false;
          return;
        }

        // ✅ success flow
        this.$store.commit("SET_USEREMAIL", this.Login.EmailID);

        this.SnackBarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "green",
          Top: true,
          SnackbarText: "Login Successful",
        };

        await this.ActivateMethod();
        this.loading = false;
      } catch (error) {
        console.log(error);
        this.loading = false;

        // ✅ handle already logged in edge case
        if (error.name === "UserAlreadyAuthenticatedException") {
          this.$router.push("/LandingPage");
          return;
        }

        this.SnackBarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "red",
          Top: true,
          SnackbarText: error.message || "Login failed",
        };
      }
    },
    ActivateMethod() {
      setTimeout(() => this.$router.push("/LandingPage"), 500);
    },
    async SendOTPLoginCode() {
      const isValid = await this.$refs.formOTPLoginEmail.validate();
      if (!isValid.valid) {
        this.SnackBarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "red",
          Top: true,
          SnackbarText: "Please enter your email address",
        };
        return;
      }
      try {
        this.loading = true;
        const result = await signIn({
          username: this.OTPLogin.EmailID,
          options: { authFlowType: "CUSTOM_WITHOUT_SRP" },
        });
        this.otpSignInResult = result;
        this.loading = false;
        if (
          result.nextStep &&
          result.nextStep.signInStep === "CONFIRM_SIGN_IN_WITH_CUSTOM_CHALLENGE"
        ) {
          this.step = 2;
          this.SnackBarComponent = {
            SnackbarVmodel: true,
            SnackbarColor: "green",
            Top: true,
            SnackbarText: "Code sent to your email",
          };
        } else {
          this.SnackBarComponent = {
            SnackbarVmodel: true,
            SnackbarColor: "red",
            Top: true,
            SnackbarText: "Unable to start sign-in with code",
          };
        }
      } catch (error) {
        this.loading = false;
        this.SnackBarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "red",
          Top: true,
          SnackbarText: error.message || "Failed to send code",
        };
      }
    },
    async VerifyOTPLoginCode() {
      const isValid = await this.$refs.formOTPLoginCode.validate();
      if (!isValid.valid) {
        return;
      }
      try {
        this.loading = true;
        const result = await confirmSignIn({
          challengeResponse: this.OTPLogin.Code,
        });
        this.loading = false;
        if (result.isSignedIn) {
          const user = await getCurrentUser();
          this.$store.commit("SET_USEREMAIL", user.signInDetails?.loginId || this.OTPLogin.EmailID);
          this.SnackBarComponent = {
            SnackbarVmodel: true,
            SnackbarColor: "green",
            Top: true,
            SnackbarText: "Login Successful",
          };
          this.ActivateMethod();
        } else {
          this.SnackBarComponent = {
            SnackbarVmodel: true,
            SnackbarColor: "red",
            Top: true,
            SnackbarText: "Incorrect code, please try again",
          };
          this.OTPLogin.Code = "";
        }
      } catch (error) {
        this.loading = false;
        this.SnackBarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "red",
          Top: true,
          SnackbarText: error.message || "Incorrect code, please try again",
        };
        this.OTPLogin.Code = "";
      }
    },
    ValidateConfirmPasswordForm() {
      if (this.$refs.formCP.validate()) {
        if (this.Password.NewPassword == this.Password.ConfirmPassword) {
          this.ConfirmPassword();
        } else {
          this.$refs.form.reset();
          this.SnackBarComponent = {
            SnackbarVmodel: true,
            SnackbarColor: "red",
            Top: true,
            SnackbarText: "Password does not match",
          };
        }
      } else {
        this.SnackBarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "red",
          Top: true,
          SnackbarText: "Fields marked with asterisks (*) are mandatory",
        };
      }
    },
    async ValidateSignUpForm() {
      const isValid = await this.$refs.form.validate();
      if (isValid.valid) {
        this.SignIn();
      } else {
        this.SnackBarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "red",
          Top: true,
          SnackbarText: "Fields marked with asterisks (*) are mandatory",
        };
      }
      // this.$router.push("/LandingPage");
    },
  },
};
</script>

<style src="@/assets/styles/login-page.css"></style>
